import React from "react";
import { Link } from "react-router";

/**
 * A card in the Studios home grid. Clicking navigates to /studios/:slug.
 */
export default function StudioCard({ studio }) {
  return (
    <Link to={`/studios/${studio.slug}`} className="studio-card">
      {studio.cover_url && (
        <div
          className="studio-card-cover"
          style={{ backgroundImage: `url(${studio.cover_url})` }}
        />
      )}
      <div className="studio-card-body">
        <div className="studio-card-title">{studio.name}</div>
        {studio.tagline && (
          <div className="studio-card-tagline">{studio.tagline}</div>
        )}
        {studio.badge && studio.badge !== "none" && (
          <div className={`studio-card-badge studio-card-badge-${studio.badge}`}>
            {studio.badge}
          </div>
        )}
      </div>
    </Link>
  );
}
